import { EvtStatsCard } from "components/stats/display-card";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";
import QueryError from "components/query-error";
import React from "react";
import { formatHoursToTime } from "components/timesheet/utils";
import { useMilestoneApprovedHours } from "components/milestone/stats/approved/useMilestoneApprovedHours";

export const MilestoneTotalApprovedHoursStat = ({ id, dateRange }) => {
  const { data, isLoading, isError, refetch, error } =
    useMilestoneApprovedHours(id, dateRange);

  if (isLoading) {
    return <EvtStatsCardPlaceholder />;
  }

  if (isError) {
    return (
      <QueryError message="Failed to load Approved hours." onRetry={refetch} />
    );
  }

  return <EvtStatsCard label="Approved" value={formatHoursToTime(data)} />;
};
